// The largest file sent between the browser and CBS's FTP through the API.
export const MAX_FTP_FILE_BYTES = 25 * 1024 * 1024;

const CONTENT_TYPES: Record<string, string> = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  txt: 'text/plain',
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

// Browsers can show these in a tab; anything else is only downloaded.
const VIEWABLE = new Set(['pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'txt']);

const extension = (fileName: string) => fileName.split('.').pop()?.toLowerCase() ?? '';

export const fileContentType = (fileName: string) =>
  CONTENT_TYPES[extension(fileName)] ?? 'application/octet-stream';

export const canViewFile = (fileName: string) => VIEWABLE.has(extension(fileName));
